import React, { FunctionComponent, useContext, useEffect } from "react";
import { AnalyticsActionType } from "../app/contexts/Analytics/types";
import { AppContext } from "../app/store";

const AnalyticsListeners: FunctionComponent = ({ children }) => {
  const { dispatch } = useContext(AppContext);

  useEffect(() => {
    function sendInternalLinkClickEvent(event: Event) {
      const target = event.target as HTMLElement;
      const link = target.closest("a");

      if (link) {
        dispatch({
          type: AnalyticsActionType.SEND_INTERNAL_LINK_CLICKED_EVENT,
          settings: {
            linkText: link.innerText,
            linkUrl: link.getAttribute("href") || "N/A",
          },
        });
      }
    }

    window.addEventListener("click", sendInternalLinkClickEvent);

    return () =>
      window.removeEventListener("click", sendInternalLinkClickEvent);
  }, []);

  return <>{children}</>;
};

export default AnalyticsListeners;
